import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';

import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import viewMore from '../../components/view-more.vue';
import { formats } from '@/common/format';
import AttomTitle from './_components/AttomTitle.vue'

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-nbr-info'
    },
    asyncData: mapAsyncData(asyncData),
    data: function() {
        return {
            nbrInfo: null,
            description: null,
            noviewmore: true,
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            currencySymbol: store => store.currency?.symbol,
            isCensusSubdivision: store => store.page?.censusSubdivision || false
        }),
        ...mapState({
            geoGraphic: store => store.geoGraphic,
            marketReport: store => store.marketReport
        }),
        cityLink({ nbrInfo, areaType }) {
            let cityLink = '';
            if (areaType === 'feature-area') {
                //new logic for feature area
                if (nbrInfo && nbrInfo.type === 'neighborhood') {
                    cityLink = nbrInfo.cityIntroUrl;
                }
            } else if (nbrInfo && nbrInfo.type === 'neighborhood') {
                if (nbrInfo.cityId && nbrInfo.city) {
                    cityLink =
                        '/neighborhood-city/' +
                        nbrInfo.cityId +
                        '/' +
                        nbrInfo.city;
                }
            }
            return cityLink;
        },
        desc() {
            var name = (this.nbrInfo && this.nbrInfo.name) || '';
            if (this.description) {
                return this.description.replace(/\{\{nbrName\}\}/g, name);
            }
            return this.$t('md-nbr-info.description', { name });
        },
        isMobile() {
            return this.platform.isMobile;
        },

        dataList({ geoGraphic, marketReport, nbrInfo }) {
            let totalListings = (+(marketReport.listingCount || 0)).toFixed(0),
                averageSalePrice = +marketReport.listingAvgPrice || 0;
            let dataList = [];
            if (nbrInfo.type === 'neighborhood' && !this.isCensusSubdivision) {
                dataList = [
                    {
                        title: this.$t('md-nbr-info.averageSalesPrice'),
                        class: 'average-sales-price',
                        value: Number(averageSalePrice || 0).toFixed(0),
                        filter: 'formatCurrency',
                        icon: 'icon-Price',
                        label: formats.currency({
                            value: Number(averageSalePrice || 0).toFixed(0),
                            noSpace: true,
                            currencySymbol: this.currencySymbol
                        })
                    },
                    {
                        title: this.$t('md-nbr-info.totalListings'),
                        class: 'total-listings',
                        value: totalListings,
                        filter: 'formatNum',
                        icon: 'icon-a-TotalListings',
                        label: formats.number(totalListings)
                    }
                ];
                // Walk Score is empty or is 0,  do not show
                var ws = (geoGraphic.walkScore || {}).walkscore;
                if (ws) {
                    dataList.push({
                        title: this.$t('md-nbr-info.walkScore'),
                        class: 'walk-score',
                        value: ws,
                        filter: 'formatNum',
                        icon: 'icon-a-WalkScore',
                        label: formats.number(ws)
                    });
                }
            } else {
                let medianSalesPrice = +marketReport.listingMedianPrice || 0;
                dataList = [
                    {
                        title: this.$t('md-nbr-info.averageSalesPrice'),
                        class: 'average-sales-price',
                        value: Number(averageSalePrice || 0).toFixed(0),
                        filter: 'formatCurrency',
                        icon: 'icon-Price',
                        label: formats.currency({
                            value: Number(averageSalePrice || 0).toFixed(0),
                            noSpace: true,
                            currencySymbol: this.currencySymbol
                        })
                    },
                    {
                        title: this.$t('md-nbr-info.medianSalesPrice'),
                        class: 'median-sales-price',
                        value: Number(medianSalesPrice || 0).toFixed(0),
                        filter: 'formatCurrency',
                        icon: 'icon-dollor',
                        label: formats.currency({
                            value: Number(medianSalesPrice || 0).toFixed(0),
                            noSpace: true,
                            currencySymbol: this.currencySymbol
                        })
                    },
                    {
                        title: this.$t('md-nbr-info.totalListings'),
                        class: 'total-listings',
                        value: totalListings,
                        filter: 'formatNum',
                        icon: 'icon-a-TotalListings',
                        label: formats.number(totalListings)
                    },
                    {
                        title: this.$t('md-nbr-info.population'),
                        class: 'population',
                        value:
                            ((geoGraphic.demographics || {}).population || {})
                                .populationCurrent ||
                            ((geoGraphic.demographics || {}).population || {})
                                .population2010 ||
                            0,
                        filter: 'formatNum',
                        icon: 'icon-Population1',
                        label: formats.number(
                            ((geoGraphic.demographics || {}).population || {})
                                .populationCurrent ||
                                (
                                    (geoGraphic.demographics || {})
                                        .population || {}
                                ).population2010
                        ),
                        helpTip: this.$t('common:attomDataDescription')
                    }
                ];
            }
            return dataList;
        }
    },
    components: {
        viewMore,
        AttomTitle
    }
};
